import styled from 'styled-components';

type Props = {
    readonly width?: number;
};

export const SidebarContainer = styled.div.attrs({ 'data-displayname': 'Sidebar' })<Props>`
    width: ${props => (props.width ? props.width : 300)}px;
    flex-shrink: 0;

    ~ div.inner-content {
        width: calc(100% - ${props => (props.width ? props.width : 300)}px);
    }
`;
